import { string, bool } from 'prop-types';

import { ActiveBorderSquare, ActiveBorderCircle } from '../Artwork.style.js';

/** Define the shape of the ActiveBorder Mask */
const ActiveBorder = ({ entityType, isVersion, ...rest }) => {
  if (isVersion) {
    switch (entityType) {
      case 'release':
      case 'list':
      case 'track':
        return (
          <ActiveBorderSquare
            x="5"
            y="5"
            width="90"
            height="90"
            rx="3"
            {...rest}
          />
        );
      default:
        return null;
    }
  } else {
    switch (entityType) {
      case 'release':
      case 'list':
      case 'track':
        return (
          <ActiveBorderSquare
            x="5"
            y="5"
            width="90"
            height="90"
            rx="3"
            {...rest}
          />
        );
      case 'artist':
      case 'label':
        return <ActiveBorderCircle cx="50" cy="50" r="50" {...rest} />;
      case 'project':
        return (
          <ActiveBorderSquare
            x="5"
            y="5"
            width="90"
            height="90"
            rx="3"
            {...rest}
          />
        );
      default:
        return null;
    }
  }
};

ActiveBorder.propTypes = {
  entityType: string.isRequired,
  isVersion: bool,
};

export default ActiveBorder;
